import { render } from "./HelpTooltip.vue?vue&type=template&id=97bb99a0&scoped=true"
import script from "./HelpTooltip.vue?vue&type=script&lang=js"
export * from "./HelpTooltip.vue?vue&type=script&lang=js"

import "./HelpTooltip.vue?vue&type=style&index=0&id=97bb99a0&scoped=true&lang=css"

import exportComponent from "/Users/aashit.kothari/Documents/jumper-ionic-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97bb99a0"]])

export default __exports__